import { SPORTSBOOK_FILTER_CLICKED } from 'Store/constants';

const initialState = {
  filterName: null,
  isActive: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SPORTSBOOK_FILTER_CLICKED:
      return {
        filterName: action.payload.filterName,
        isActive: action.payload.isActive,
      };
    
    default:
      return state;
  }
};